export const STORAGE = {
  AUTH: 'auth_info',
  SESSION: 'user_session',
  ORDER_SESSION: 'order_session',
  SALES_SESSION: 'sales_session',
};
